
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { PartnerService } from '../services/partner.service';
import { UtilsService } from '@services/utils.service';

@Injectable()
export class PartnerResolver implements Resolve<any> {
    constructor(private partnerService: PartnerService, private readonly utilsService: UtilsService) { }
    public resolve(route: ActivatedRouteSnapshot) {
        const partnerId = this.utilsService.findUpRouteParams(route, 'partnerId');
        return this.partnerService.findOne(partnerId);
    }
}
